import { render, staticRenderFns } from "./ArticleDetailsTable.vue?vue&type=template&id=1dbac9e6&scoped=true&"
import script from "./ArticleDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailsTable.vue?vue&type=style&index=0&id=1dbac9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbac9e6",
  null
  
)

export default component.exports